<template>
  <!--<? if ($new_product->category->is_active): ?>-->
  <div class="card w-100 new-product-slider">
    <div class="card-body">
      <!--      <Loader v-if="loading"></Loader>-->
      <div class="row">
        <div class="col-6">
          <div class="zoom" style="overflow: visible">
            <span v-if="product.old_price" class="sticker-new rubik"
            >- {{ discount }} %
            </span>
            <router-link
              @click.prevent="$scrollToTop"
              :to="{
                name: 'ProductDetail',
                params: { alias: product.alias },
              }"
            >
              <img :data-src="`../../../../img/products/${product.alias}/upper-banner-${product.id}.jpg`"
                   :src="require(`/src/assets/img/loading.gif`)"
                   :alt="product.alias"
                   class="m-auto"
                   style="max-width: 300px;"
              />
            </router-link>
          </div>
        </div>
        <div class="col-6">
          <div class="product-rating mb-2">
            <i v-for="r in ratingYes" :key="r" class="fa fa-star mr-1"></i>
            <i
              v-for="r in ratingNo"
              :key="r"
              class="i-color fa fa-star mr-1"
            ></i>
          </div>
          <router-link
            :to="{
              name: 'ProductDetail',
              params: { alias: product.alias },
            }"
          >
            <h4
              class="
                card-title
                font-weight-bold font-alice
                product-title-slider
              "
            >
              {{ product.title }}
            </h4>
          </router-link>
          <p
            v-if="checkScreena"
            class="mb-2"
            v-snip:[method]="truncRows"
            v-html="rawHtml"
          ></p>
          <p>
            <span class="price font-weight-bolder"
            >Цена: {{ $cur(product.price) }}</span
            >
            <del v-if="product.old_price" class="prev-price text-danger">
              {{ $cur(product.old_price) }}
            </del>
            <br>
            <span v-if="product.type === 'weight' && parseFloat(product.inStock) !== 0" class="badge badge-success">В наличии: {{ product.inStock }} кг.</span>
            <span v-else-if="product.type === 'piece' && parseFloat(product.inStock) !== 0" class="badge badge-success">В наличии: {{ parseInt(product.inStock) }} шт.</span>
            <span v-else-if="parseFloat(product.inStock) === 0" class="badge badge-danger">Нет в наличии</span>
          </p>
          <div class="mt-3">
            <button
              class="btn btn-warning rounded m-0"
              type="button"
              @click.prevent="addToCart(product.id)"
              title="Добавить товар в корзину"
              :class="{disabled: product.inStock <= 0}"
            >
              В корзину
            </button>
            <span class="counter" v-if="product.qty > 0">{{ allQty }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--<? endif; ?>-->
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    product: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  components: {},

  data() {
    return {
      // loading: true,
      method: "js",
      discount: null,
      ratingYes: null,
      ratingNo: null,
      rawHtml: this.product.content,
      truncRows: null,
      checkScreena: false,
      qty: 0,
      socQty: 0,
      inStock: 0
    };
  },
  created() {
    window.addEventListener("resize", this.checkScreen);
    this.checkScreen();
    this.allQty = this.qty + this.socQty;
  },

  computed: {
    allQty() {
      return this.product.qty + this.product.socQty;
    }
  },

  methods: {
    ...mapActions({
      ADD_TO_CART: "products/ADD_TO_CART"
    }),
    addToCart(id) {
      this.ADD_TO_CART(id);
      this.$toast.success(
        `<i class="fas fa-cart-plus" style="font-size: 20px;"> ${this.product.title}</i>`
      );
      this.qty = this.product.qty;
      this.socQty = this.product.socQty;
      this.allQty = this.qty + this.socQty;
    },
    checkScreen() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth > 991) {
        this.truncRows = 4;
        this.checkScreena = true;
      }
      if (this.windowWidth <= 991) {
        this.truncRows = 1;
        this.checkScreena = true;
      }
      if (this.windowWidth <= 564) {
        this.truncRows = null;
        this.checkScreena = false;
      }
    }
  },
  mounted() {
    this.qty = this.product.qty;
    this.socQty = this.product.socQty;
    this.allQty = this.qty + this.socQty;
    this.discount = parseInt(
      (this.product.old_price / this.product.price) * 100 - 100
    );
    this.ratingYes = this.product.rating;
    this.ratingNo = 5 - this.ratingYes;
  }
};
</script>

<style scoped></style>
